export const GO_TO_PARTNERS = ['qasa']
